import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-ef9772d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "service-wrap pt-20 pb-20" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row mb-5" }
const _hoisted_4 = { class: "col-12 text-center" }
const _hoisted_5 = { class: "text-wrapper" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "section-text" }, [
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("br")
  ])
], -1))
const _hoisted_8 = { class: "search-wrapper mb-4" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { type: "submit" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-search-interface-symbol" })
], -1))
const _hoisted_10 = { class: "row g-4" }
const _hoisted_11 = { class: "prof-mini-card" }
const _hoisted_12 = ["src"]
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "prof-mini-name" }
const _hoisted_15 = { class: "mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("p", {
              class: _normalizeClass(["section-text", { collapsed: !_ctx.isExpanded }])
            }, [
              _createTextVNode(" Vous serez appelés d’un nom nouveau : Disciples d’Emmaüs Le chrétien, en Afrique comme dans le monde, est souvent bouleversé ou désemparé par la complexité de divers problèmes existentiels à affronter. Se sentant bien des fois démuni et abandonné, le disciple du Christ est parfois déçu ou même vaincu par de nombreux défis sociopolitiques et culturels. Au regard de ces enjeux, l’École d’Initiation Théologique et Pastorale (EITP) de l’archidiocèse de Cotonou compte modestement, par la mise en relation dynamique et organique de la foi avec la raison et les cultures, se constituer comme le chemin où le croyant marche aux côtés de Jésus-Christ. Le Christ est vraiment Celui qui n’abandonne jamais l’homme seul sur sa route de doute ou de désespoir ; Il chemine plutôt avec lui et le guide par la lumière de sa Divine Parole. A travers les données essentielles de la foi à approfondir afin de pouvoir en rendre convenablement compte, c’est l’expérience de l’heureuse rencontre avec le Christ qui est proposée. Aussi le cheminement à l’EITP peut-il être comparé à la route parcourue par les deux disciples du Christ (Lc 24), partis de Jérusalem vers Emmaüs, mais rejoints par le Ressuscité qui les instruit et les nourrit. Les yeux de leur intelligence de la foi se sont ainsi ouverts pour reconnaître leur Seigneur et Sauveur, à la fraction du pain. La culture de la foi requiert la vie des mystères de la foi. Après la rencontre avec le Crucifié Ressuscité, les disciples d’Emmaüs s’engagent, à l’instant et désormais, sur les chemins du témoignage, aujourd’hui plus nombreux et divers, pour annoncer la Bonne Nouvelle de la victoire de l’amour sur la haine, de la vie sur la mort, de la lumière sur les ténèbres. A nous d’en être les témoins crédibles, partout et toujours. L’EITP voudrait alors nous aider à devenir les nouveaux Disciples d’Emmaüs, véritables chercheurs de Dieu dont a tant besoin le monde de notre temps. "),
              _hoisted_6,
              _createTextVNode(" Les Disciples suivent toute la formation (deux années) et valident tous les modules autant par la présence que par les devoirs et l’examen final. Ils publient un mémoire et une authentification de fin de formation à la Cérémonie académique. Ils sont envoyés en mission lors d’une messe. ")
            ], 2),
            _createElementVNode("button", {
              class: "toggle-btn",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isExpanded = !_ctx.isExpanded))
            }, _toDisplayString(_ctx.isExpanded ? "Voir moins" : "Voir plus"), 1)
          ])
        ]),
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("form", {
            class: "search-box",
            onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args)), ["prevent"]))
          }, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchTerm) = $event)),
              onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args))),
              placeholder: "Rechercher un disciple (nom ou prénom)..."
            }, null, 544), [
              [_vModelText, _ctx.searchTerm]
            ]),
            _hoisted_9
          ], 32)
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.etudiants, (etu) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "col-xl-3 col-lg-3 col-md-4 col-sm-6",
            key: etu.id
          }, [
            _createElementVNode("div", _hoisted_11, [
              (etu.user?.urlImage)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _ctx.getImageUrl(etu.user.urlImage),
                    alt: "Photo disciple",
                    class: "prof-photo"
                  }, null, 8, _hoisted_12))
                : (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    src: _ctx.defaultPhoto,
                    alt: "Photo par défaut",
                    class: "prof-photo"
                  }, null, 8, _hoisted_13)),
              _createElementVNode("h5", _hoisted_14, [
                _createVNode(_component_router_link, {
                  to: `/disciplesEmmaius/${etu.id}`,
                  class: "prof-link"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(etu.nom) + " " + _toDisplayString(etu.prenom), 1)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ])
            ])
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createVNode(_component_PaginationComponent, {
          page: _ctx.page,
          totalPages: _ctx.totalPages,
          totalElements: _ctx.totalElements,
          limit: _ctx.limit,
          onPaginate: _ctx.handlePaginate
        }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
      ])
    ])
  ]))
}